import { createContext, useEffect, useMemo, useState } from "react";
import { userDecrypt } from "../helpers/HelperFunctions";
import { getFirebaseUser } from "../helpers/FirebaseFunctions";
import { IAppointmentReport, IAppointmentReportContext } from "../helpers/Interfaces";


export const User = createContext([] as any[]);
export const FirebaseUser = createContext([] as any);
export const AppointmentReport = createContext<IAppointmentReportContext>({} as IAppointmentReportContext);

export default function Store({ children }: any) {

    const [user, setUser] = useState(null as any);
    const [firebaseUser, setFirebaseUser] = useState(null as any);
    const [appointmentReport, setAppointmentReport] = useState<IAppointmentReport>
        ({
            clinicName: '', patientName: '', dateOfAssessment: null, appointmentId: null,
            notes: "", paperworkReceived: null, invoiceStatus: null, referrerId: null
        });
    useEffect(() => {
        if (sessionStorage.getItem("user") !== null && user == null) {
            setUser(userDecrypt());
        }

        if (user?.notificationId && firebaseUser == null) {
            getFirebaseUser(user?.notificationId, setFirebaseUser);
        }
    }, [user])

    const changeAppointmentReport = (value: IAppointmentReport) => {
        setAppointmentReport(value);
    }

    const changeAppointmentReportContext = useMemo(() => ({
        patientName: appointmentReport.patientName,
        clinicName: appointmentReport.clinicName,
        dateOfAssessment: appointmentReport.dateOfAssessment ? appointmentReport.dateOfAssessment : new Date(),
        appointmentId: appointmentReport.appointmentId,
        notes: appointmentReport.notes,
        paperworkReceived: appointmentReport.paperworkReceived,
        invoiceStatus: appointmentReport.invoiceStatus,
        referrerId: appointmentReport.referrerId,
        changeAppointmentReport
    }), [appointmentReport.clinicName, appointmentReport.patientName, appointmentReport.appointmentId, appointmentReport.notes]);

    return (
        <User.Provider value={[user, setUser]}>
            <FirebaseUser.Provider value={[firebaseUser, setFirebaseUser]}>
                <AppointmentReport.Provider value={changeAppointmentReportContext}>
                    {children}
                </AppointmentReport.Provider>
            </FirebaseUser.Provider>
        </User.Provider>
    );
}
